<script>
import RentalProductService from '@/services/rentalModule/RentalProductService'
import RegionCodeService from '@/services/RegionCodeService'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator'
import { VPhoneInput } from 'v-phone-input'
import DepositTypeConstant from '@/constants/rentalModule/depositTypeConstant'
import RentalPdfService from '@/services/rentalModule/RentalPdfService'
import RentalFileService from '@/services/rentalModule/RentalFileService'
import AvailabilityStatusConstant from '@/constants/rentalModule/availabilityStatusConstant'

export default {
  name: 'RentalFileCreatePage',
  computed: {
    DepositTypeConstant() {
      return DepositTypeConstant
    }
  },
  components: { VPhoneInput },
  data() {
    const date = new Date()
    date.setDate(date.getUTCDate())
    date.setHours(0, 0, 0, 0)

    return {
      loading: false,
      pageLoaded: false,

      formValid: false,

      repairFileBoomerangId: null,
      rentalProductId: null,
      rentalProduct: null,

      error: null,

      requiredRules: Validator.requiredRules,
      max255CharRules: Validator.max255CharRules,
      emailRules: Validator.emailRules,

      clientCompanyName: null,
      clientFullName: null,
      clientEmail: null,
      clientPhoneNumber: null,

      selectedCountry: null,
      allCountries: [],

      clientCompanyAddressName: null,
      clientCompanyAddressNumber: null,
      clientCompanyAddressStreet: null,
      clientCompanyAddressZipCode: null,
      clientCompanyAddressCity: null,
      clientCompanyAddressCountry: null,

      billingAddressIsSame: true,
      clientBillingAddressName: null,
      clientBillingAddressNumber: null,
      clientBillingAddressStreet: null,
      clientBillingAddressZipCode: null,
      clientBillingAddressCity: null,
      clientBillingAddressCountry: null,

      desiredDeliveryDate: date,
      today: new Date(),

      depositType: DepositTypeConstant.STORE,

      commentary: null,

      showValidDate: false
    }
  },
  async created() {
    this.repairFileBoomerangId = this.$store.getters['auth/getRentalRepairFileBoomerangId']
    this.rentalProductId = this.$route.params.rentalProductId

    const response = await RegionCodeService.getRegionCodeList()
    this.allCountries = await this.getCountryCode(response.item_list)

    await this.getRentalProductDetail()

    this.pageLoaded = true
  },
  methods: {
    formatDate() {
      const date = this.desiredDeliveryDate
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },
    async getRentalProductDetail() {
      this.loading = true
      try {
        this.rentalProduct =
          await RentalProductService.getRentalProductDetailById(this.rentalProductId)
        if (this.rentalProduct.rental_status !== AvailabilityStatusConstant.AVAILABLE) {
          displayToast(this.$t('RENTAL_MODULE_LIST_PRODUCTS_PAGE.AVAILABILITY_ERROR'), 'error')
          this.$router.push('/rental-module/product-list/'
            + this.$store.getters['auth/getRentalRepairFileBoomerangId'])
        }
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    getCountryCode(zones) {
      return zones.map((item) => {
        return item.country_code
      })
    },
    backToRentalProductDetail() {
      this.$router.push('/rental-module/product-detail/' + this.rentalProductId)
    },
    async getRentalContractPdf() {
      try {
        this.loading = true
        const response = await RentalPdfService.getRentalContractPdf(this.rentalProductId)
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'condition_generales_de_location_'
          + this.rentalProductId + '.pdf');
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async submitRental() {
      this.loading = true

      const year = this.desiredDeliveryDate.getFullYear()
      const month = (this.desiredDeliveryDate.getMonth() + 1).toString().padStart(2, '0')
      const day = this.desiredDeliveryDate.getDate().toString().padStart(2, '0')
      const desiredDeliveryDateFormated = `${year}-${month}-${day}`

      const data = {
        rental_product_id: this.rentalProductId,
        repair_file_boomerang_id: this.repairFileBoomerangId,
        company_name: this.clientCompanyName,
        client_fullname: this.clientFullName,
        client_email: this.clientEmail,
        client_phone: this.clientPhoneNumber,
        delivery_address_name: this.clientCompanyAddressName,
        delivery_address_number: this.clientCompanyAddressNumber,
        delivery_address_street: this.clientCompanyAddressStreet,
        delivery_address_zip_code: this.clientCompanyAddressZipCode,
        delivery_address_city: this.clientCompanyAddressCity,
        delivery_address_country: this.clientCompanyAddressCountry,
        company_address_name: this.billingAddressIsSame === false
          ? this.clientBillingAddressName : this.clientCompanyAddressName,
        company_address_number: this.billingAddressIsSame === false
          ? this.clientBillingAddressNumber : this.clientCompanyAddressNumber,
        company_address_street: this.billingAddressIsSame === false
          ? this.clientBillingAddressStreet : this.clientCompanyAddressStreet,
        company_address_zip_code: this.billingAddressIsSame === false
          ? this.clientBillingAddressZipCode : this.clientCompanyAddressZipCode,
        company_address_city: this.billingAddressIsSame === false
          ? this.clientBillingAddressCity : this.clientCompanyAddressCity,
        company_address_country: this.billingAddressIsSame === false
          ? this.clientBillingAddressCountry : this.clientCompanyAddressCountry,
        desired_customer_reception_date: desiredDeliveryDateFormated,
        description: this.commentary,
        deposit_type: this.depositType
      }

      try {
        const response = await RentalFileService.createRentalFile(data)
        this.$store.commit('auth/resetRentalRepairFileBoomerangId')
        this.$router.push('/rental-module/rental-file-detail/' + response.rental_file_id)
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-container fluid>
    <v-row cols="12" v-if="pageLoaded">
      <!-- LEFT PART: PICTURE + DETAIL -->
      <v-col cols="6" class="left-container">
        <!-- PICTURE -->
        <v-card class="picture-card">
          <div class="picture">
            <v-col v-if="rentalProduct.product_picture">
              <v-img class="picture-content"
                     :src="rentalProduct.product_picture"
                     alt="Product Preview"/>
            </v-col>
          </div>
        </v-card>

        <!-- RENTAL COST SUMMARY -->
        <v-card class="mt-6 pa-5 summary-card">
          <v-card-text>
            <p class="font-weight-black d-flex">
              {{ $t('RENTAL_MODULE_PRODUCT_DETAIL_PAGE.SUMMARY_TEXT') }}
            </p>
          </v-card-text>
          <v-card-text>
            <v-row cols="12" justify="space-between">
              <v-col cols="auto my-0 py-0">
                {{ $t('RENTAL_MODULE_PRODUCT_DETAIL_PAGE.HT_PRICE') }}
              </v-col>
              <v-col cols="auto my-0 py-0 font-weight-black">
                {{ rentalProduct.rental_price.toFixed(2) }} {{ $t('COMMON.EURO') }}
              </v-col>
            </v-row>
            <v-row cols="12" justify="space-between">
              <v-col cols="auto my-O py-0">
                {{ $t('RENTAL_MODULE_PRODUCT_DETAIL_PAGE.DEPOSIT') }}
              </v-col>
              <v-col cols="auto my-O py-0 font-weight-black">
                {{ rentalProduct.rental_deposit.toFixed(2) }} {{ $t('COMMON.EURO') }}
              </v-col>
            </v-row>
            <v-row cols="12" justify="space-between">
              <v-col cols="auto my-O py-0">
                {{ $t('RENTAL_MODULE_PRODUCT_DETAIL_PAGE.DELIVERY_TOTAL') }}
              </v-col>
              <v-col cols="auto my-O pt-0 pb-3 free-shipping font-weight-black">
                {{ $t('RENTAL_MODULE_PRODUCT_DETAIL_PAGE.FREE_DELIVERY') }}
              </v-col>
            </v-row>
            <v-divider/>
            <v-row cols="12" justify="space-between" class="py-1">
              <v-col cols="auto font-weight-black">
                {{ $t('RENTAL_MODULE_PRODUCT_DETAIL_PAGE.HT_TOTAL') }}
              </v-col>
              <v-col cols="auto font-weight-black">
                {{ (rentalProduct.rental_price
                  + rentalProduct.rental_deposit).toFixed(2) }} {{ $t('COMMON.EURO') }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- NEXT STEP CARD -->
        <v-card class="mt-6 pa-5 next-step-card">
          <v-card-text class="font-weight-black">
            {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.TITLE') }}
          </v-card-text>
          <v-card-text class="pt-0">
            <div>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P1') }}
            </div>
            <div>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P2') }}
            </div>
            <div>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P3') }}<br>
              <span class="text grey">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P3_DOT') }}
              </span>
            </div>
            <div>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P4') }}
            </div>
            <div>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P5') }}
            </div>
            <div class="mt-2 font-italic">
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.SP2') }}
            </div>
            <li>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.SP2_1') }}
            </li>
            <li>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.SP2_2') }}
            </li>
            <div class="mt-2">
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P6') }}
            </div>
            <div>
              {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.NEXT_STEP_CARD.P7') }}
            </div>
          </v-card-text>
        </v-card>

        <!--BACK BUTTON-->
        <v-row cols="12" class="mt-3" >
          <v-col cols="2">
            <v-btn class="boom-button-back"
                   variant="outlined"
                   @click="backToRentalProductDetail()"
            >
              {{ $t('COMMON.BUTTON.BACK') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <!-- RIGHT PART: FORM -->
      <v-col cols="6">
        <v-form
          ref="formRentalCreate"
          v-model="formValid"
          @submit.prevent="submitRental"
        >
          <v-card class="form-card">

            <v-col cols="12">
              <h2 class="font-weight-bold title content">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.TITLE') }}
              </h2>
            </v-col>

            <!--COMPANY NAME-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMPANY_NAME_LABEL') }}
              </p>
              <v-text-field
                v-model="clientCompanyName"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientCompanyName"
                hide-details="auto"
              />
            </v-col>

            <!--CLIENT FULLNAME-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.CLIENT_FULLNAME_LABEL') }}
              </p>
              <v-text-field
                v-model="clientFullName"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientFullName"
                hide-details="auto"
              />
            </v-col>

            <!--CLIENT EMAIL-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.CLIENT_EMAIL_LABEL') }}
              </p>
              <v-text-field
                v-model="clientEmail"
                maxlength="255"
                :rules="[...requiredRules, ...emailRules, ...max255CharRules]"
                :error-messages="error?.clientEmail"
                hide-details="auto"
              />
            </v-col>

            <!--CLIENT PHONE NUMBER-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.CLIENT_PHONE_NUMBER_LABEL') }}
              </p>
              <v-phone-input
                v-model="clientPhoneNumber"
                v-model:country="selectedCountry"
                :includeCountries="allCountries"
                :rules="requiredRules"
                :error-messages="error?.phoneNumber"
              />
            </v-col>

            <!--COMPANY ADDRESS NAME-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMPANY_ADDRESS_NAME_LABEL') }}
              </p>
              <v-text-field
                v-model="clientCompanyAddressName"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientCompanyAddressName"
                hide-details="auto"
              />
            </v-col>

            <!--COMPANY_ADDRESS_NUMBER-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMPANY_ADDRESS_NUMBER_LABEL') }}
              </p>
              <v-text-field
                v-model="clientCompanyAddressNumber"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientCompanyAddressNumber"
                hide-details="auto"
              />
            </v-col>

            <!--COMPANY_ADDRESS_STREET-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMPANY_ADDRESS_STREET_LABEL') }}
              </p>
              <v-text-field
                v-model="clientCompanyAddressStreet"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientCompanyAddressStreet"
                hide-details="auto"
              />
            </v-col>

            <!--COMPANY_ADDRESS_ZIP_CODE-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMPANY_ADDRESS_ZIP_CODE_LABEL') }}
              </p>
              <v-text-field
                v-model="clientCompanyAddressZipCode"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientCompanyAddressZipCode"
                hide-details="auto"
              />
            </v-col>

            <!--COMPANY_ADDRESS_CITY-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMPANY_ADDRESS_CITY_LABEL') }}
              </p>
              <v-text-field
                v-model="clientCompanyAddressCity"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientCompanyAddressCity"
                hide-details="auto"
              />
            </v-col>

            <!--COMPANY_ADDRESS_COUNTRY-->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMPANY_ADDRESS_COUNTRY_LABEL') }}
              </p>
              <v-text-field
                v-model="clientCompanyAddressCountry"
                maxlength="255"
                :rules="[...requiredRules, ...max255CharRules]"
                :error-messages="error?.clientCompanyAddressCountry"
                hide-details="auto"
              />
            </v-col>

            <!-- BILLING ADDRESS STATUS-->
            <div class="checkbox-custom">
              <v-col md="1" class="pa-0">
                <v-checkbox hide-details color="#559a1b"
                            v-model="billingAddressIsSame"
                            class="checkbox"/>
              </v-col>
              <v-col class="checkbox pb-0 pt-4 pl-0">
                <p>{{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.BILLING_ADDRESS_STATUS_LABEL') }}</p>
              </v-col>
            </div>

            <!-- BILLING ADDRESS -->
            <div v-if="!billingAddressIsSame">
              <!--BILLING ADDRESS NAME-->
              <v-col cols="12">
                <p class="text-field" required="true">
                  {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.BILLING_ADDRESS_NAME_LABEL') }}
                </p>
                <v-text-field
                  v-model="clientBillingAddressName"
                  maxlength="255"
                  :rules="[...requiredRules, ...max255CharRules]"
                  :error-messages="error?.clientBillingAddressName"
                  hide-details="auto"
                />
              </v-col>

              <!--BILLING_ADDRESS_NUMBER-->
              <v-col cols="12">
                <p class="text-field" required="true">
                  {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.BILLING_ADDRESS_NUMBER_LABEL') }}
                </p>
                <v-text-field
                  v-model="clientBillingAddressNumber"
                  maxlength="255"
                  :rules="[...requiredRules, ...max255CharRules]"
                  :error-messages="error?.clientBillingAddressNumber"
                  hide-details="auto"
                />
              </v-col>

              <!--BILLING_ADDRESS_STREET-->
              <v-col cols="12">
                <p class="text-field" required="true">
                  {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.BILLING_ADDRESS_STREET_LABEL') }}
                </p>
                <v-text-field
                  v-model="clientBillingAddressStreet"
                  maxlength="255"
                  :rules="[...requiredRules, ...max255CharRules]"
                  :error-messages="error?.clientBillingAddressStreet"
                  hide-details="auto"
                />
              </v-col>

              <!--BILLING_ADDRESS_ZIP_CODE-->
              <v-col cols="12">
                <p class="text-field" required="true">
                  {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.BILLING_ADDRESS_ZIP_CODE_LABEL') }}
                </p>
                <v-text-field
                  v-model="clientBillingAddressZipCode"
                  maxlength="255"
                  :rules="[...requiredRules, ...max255CharRules]"
                  :error-messages="error?.clientBillingAddressZipCode"
                  hide-details="auto"
                />
              </v-col>

              <!--BILLING_ADDRESS_CITY-->
              <v-col cols="12">
                <p class="text-field" required="true">
                  {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.BILLING_ADDRESS_CITY_LABEL') }}
                </p>
                <v-text-field
                  v-model="clientBillingAddressCity"
                  maxlength="255"
                  :rules="[...requiredRules, ...max255CharRules]"
                  :error-messages="error?.clientBillingAddressCity"
                  hide-details="auto"
                />
              </v-col>

              <!--BILLING_ADDRESS_COUNTRY-->
              <v-col cols="12">
                <p class="text-field" required="true">
                  {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.BILLING_ADDRESS_COUNTRY_LABEL') }}
                </p>
                <v-text-field
                  v-model="clientBillingAddressCountry"
                  maxlength="255"
                  :rules="[...requiredRules, ...max255CharRules]"
                  :error-messages="error?.clientBillingAddressCountry"
                  hide-details="auto"
                />
              </v-col>
            </div>

            <!-- DESIRED DELIVERY DATE -->
            <v-col cols="6">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.DESIRED_DELIVERY_DATE_LABEL') }}
              </p>
              <div class="d-flex align-center ">
                <v-menu
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      alt="export"
                      class="date-picker"
                      src="@/assets/icons/repair-file-list/date.svg"
                      @click="showValidDate = true"
                    />
                    <v-text-field
                      v-bind="props"
                      class="ml-3 date-creation"
                      v-model="desiredDeliveryDate"
                      :value="formatDate()"
                      readonly
                      hide-details
                      @click="showValidDate = true"
                    />
                    <v-icon icon="mdi-check-circle-outline"
                            color="#767676"
                            class="update-icon"
                            v-if="showValidDate"
                            @click="showValidDate = false"
                    />
                  </template>
                  <v-locale-provider locale="fr">
                    <v-date-picker
                      v-model="desiredDeliveryDate"
                      hide-header
                      color="#559A1B"
                      locale="fr"
                      :min="today"
                      @focusin="showValidDate = true"
                    />
                  </v-locale-provider>
                </v-menu>
              </div>
            </v-col>

            <!-- DEPOSIT -->
            <v-col cols="12">
              <p class="text-field" required="true">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.DEPOSIT_LABEL') }}
              </p>
              <v-radio-group v-model="depositType" hide-details>

                <v-radio color="#559a1b"
                         :value="DepositTypeConstant.STORE"
                         :label="$t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.DEPOSIT_VALUE_1_LABEL')"
                />
                <v-radio color="#559a1b"
                         :value="DepositTypeConstant.SWIKLY"
                         :label="$t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.DEPOSIT_VALUE_2_LABEL')"
                />
              </v-radio-group>
            </v-col>

            <!-- COMMENT -->
            <v-col cols="12">
              <p class="text-field">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMMENT_LABEL') }}
              </p>
              <v-textarea
                v-model="commentary"
                :placeholder="$t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.COMMENT_PLACEHOLDER')"
                rows="5"
                hide-details
              />
            </v-col>

            <!-- CONTRACT -->
            <v-col cols="12">
              <p class="text-field">
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.CONTRACT_LABEL') }}
              </p>
              <div class="contract-card-container">
                <v-card link :disabled="loading"
                        @click.stop.prevent="getRentalContractPdf()"
                        class="content-card rounded-xl flex-fill">
                  <img alt="dialog-icon"
                       class="svg-check-rounded"
                       src="@/assets/icons/file/file.svg"/>
                  <p class="text-decoration-underline">
                    {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.CARD_LABEL') }}
                  </p>
                </v-card>
              </div>
            </v-col>

            <!-- Validation BTN -->
            <v-col cols="12">
              <v-btn
                :disabled="!formValid"
                :loading="loading"
                class="pl-15 pr-15 ml-2 validation-btn"
                :class="!formValid ? 'boom-button-transparent' : 'boom-button'"
                type="submit"
                variant="outlined"
              >
                {{ $t('RENTAL_MODULE_CREATE_FILE_PAGE.FORM.VALIDATION') }}
              </v-btn>
            </v-col>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.v-container {
  padding: 32px;
}

.v-card {
  padding: 20px;
}

.picture-card {
  box-shadow: unset;
  max-width: 90%;
  border: 1px solid #DADADA;
  padding: 10px;
  border-radius: 30px;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;

  min-height: 400px;
  height: 400px;
  max-height: 400px;

  .picture .picture-content{
    margin: auto;
    width: 300px;
    height: 300px;
  }
}

.summary-card {
  box-shadow: unset;
  max-width: 90%;
  border-radius: 30px;
}

.next-step-card {
  box-shadow: unset;
  max-width: 90%;
  border-radius: 30px;
}

.form-card {
  box-shadow: unset;
  border-radius: 30px;
}

.text-field {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 10px;
}

.checkbox-custom {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
}

.checkbox {
  white-space: pre-line;
}

.contract-card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.content-card {
  display: flex;
  max-height: 150px;
  max-width: 150px;
  gap: 10px;
  padding: 20px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 20px;
  border: 1px solid #DADADA;
  background: #FFF;
  box-shadow: 6px 6px 12px 0 rgba(218, 218, 218, 0.40);
}

.validation-btn {
  width: inherit;
}

.left-container {
  justify-content: space-between;
  flex-direction: column;
  display: flex;
}

.text {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: black;
}

.grey {
  color: #ACACAC;
}

.title {
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.date-picker {
  width: 16px;
  filter: invert(48%) sepia(0%) saturate(78%) hue-rotate(135deg) brightness(95%) contrast(83%)
}

.date-creation {
  display: flex;
  justify-items: center;
  color: #767676;
  padding: 4px;
  min-width: 125px;
}

.date-picker, .date-creation {
  cursor: pointer;
}
</style>
